import { render } from "./BrandFilter.vue?vue&type=template&id=10816418"
import script from "./BrandFilter.vue?vue&type=script&lang=js"
export * from "./BrandFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/BrandFilter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10816418"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10816418', __exports__)) {
    api.reload('10816418', __exports__)
  }
  
  module.hot.accept("./BrandFilter.vue?vue&type=template&id=10816418", () => {
    api.rerender('10816418', render)
  })

}


export default __exports__